import React, { useEffect, useRef } from 'react';
import styles from './DefaultPageLayout.module.scss';
import { RichText } from '../../scripts/contentful';
import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

const DefaultPageLayout = ({ textContent }) => {
  const defaultRef = useRef(null);

  // Turn navbar in gradient
  useEffect(() => {
    ScrollTrigger.matchMedia({
      // desktop
      '(min-width: 800px)': function () {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: defaultRef.current,
            scrub: true,
            start: `top ${25 + 20 + 32}`,
            end: `top ${25 + 20}`,
          },
        });

        tl.to(
          '#t-menuHamburger div span:nth-child(1)',
          { background: 'var(--blue)', duration: 1 },
          0
        )
          .to(
            '#t-menuHamburger div span:nth-child(2)',
            { background: '#6462b8', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger div span:nth-child(3)',
            { background: 'var(--purple)', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger p',
            { color: 'var(--darkGrey)', duration: 1 },
            0
          )
          .to(
            '#logo',
            {
              '-webkit-filter': 'brightness(1)',
              filter: 'brightness(1)',
            },
            0
          )
          .to('#filArianne p', { color: 'var(--darkGrey)', duration: 1 }, 0);
      },

      // small
      '(min-width: 600px) and (max-width: 799px)': function () {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: defaultRef.current,
            scrub: true,
            start: `top ${20 + 20 + 32}`,
            end: `top ${20 + 20}`,
          },
        });

        tl.to(
          '#t-menuHamburger div span:nth-child(1)',
          { background: 'var(--blue)', duration: 1 },
          0
        )
          .to(
            '#t-menuHamburger div span:nth-child(2)',
            { background: '#6462b8', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger div span:nth-child(3)',
            { background: 'var(--purple)', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger p',
            { color: 'var(--darkGrey)', duration: 1 },
            0
          )
          .to(
            '#logo',
            {
              '-webkit-filter': 'brightness(1)',
              filter: 'brightness(1)',
            },
            0
          )
          .to('#filArianne p', { color: 'var(--darkGrey)', duration: 1 }, 0);
      },

      // mobile
      '(max-width: 599px)': function () {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: defaultRef.current,
            scrub: true,
            start: `top ${15 + 15 + 32}`,
            end: `top ${15 + 15}`,
          },
        });

        tl.to(
          '#t-menuHamburger div span:nth-child(1)',
          { background: 'var(--blue)', duration: 1 },
          0
        )
          .to(
            '#t-menuHamburger div span:nth-child(2)',
            { background: '#6462b8', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger div span:nth-child(3)',
            { background: 'var(--purple)', duration: 1 },
            0
          )
          .to(
            '#t-menuHamburger p',
            { color: 'var(--darkGrey)', duration: 1 },
            0
          )
          .to(
            '#logo',
            {
              '-webkit-filter': 'brightness(1)',
              filter: 'brightness(1)',
            },
            0
          )
          .to('#filArianne p', { color: 'var(--darkGrey)', duration: 1 }, 0);
      },
    });
  }, []);

  // add gradient background to nav tag
  useEffect(() => {
    ScrollTrigger.create({
      trigger: defaultRef.current,
      scrub: true,
      start: 'top',
      end: 'top',
      onEnter: () => {
        gsap.set('#nav', {
          duration: 1,
          background: `linear-gradient(180deg,
          rgba(255,255,255,1) 65%,
          rgba(255,255,255,0.9) 70%,
          rgba(255,255,255,0.6) 80%,
          rgba(255,255,255,0.5) 85%,
          rgba(255,255,255,0.0) 100%)
        `,
        });
      },
      onEnterBack: () => {
        gsap.set('#nav', {
          background: 'transparent',
        });
      },
    });
  }, []);
  return (
    <section className={styles.Card} ref={defaultRef}>
      <div className={`${styles.Card__content} layout`}>
        {textContent && <RichText content={textContent.json} />}
      </div>
    </section>
  );
};

export default DefaultPageLayout;
